import type { CustomCellRendererProps } from "ag-grid-react";

import style from "../styles/Cell.module.css";
import { StrandDisplay } from "./StrandDisplay.tsx";

export const StrandCell = (props: CustomCellRendererProps) => {
  return (
    <div className={style.cell}>
      <StrandDisplay strand={props.value} />
    </div>
  );
};
